export const ScheduleType = [
    {
        key: 'notification:schedule:fix',
        value: 'FIXED_TIME'
    },
    {
        key: 'notification:schedule:lastHour_1',
        value: 'LAST_X_HOURS'
    },
    {
        key: 'notification:schedule:sync',
        value: 'SYNCHRONISED_LAST_HOUR'
    },
    {
        key: 'notification:schedule:lastWeek',
        value: 'LAST_WEEK'
    },

] as const